import { queryOptions, useQuery } from '@tanstack/react-query';


import { baseAPI } from '~shared/api/base-api';
import { QUERY_KEYS } from '~shared/api/query-keys';

import type { UserWithRole } from '../model/types';

export const getAllUsersAPI = async () => {
  const response = await baseAPI.get<Array<UserWithRole>>(`/users/all`);
  return response.data;
};

export const getAllUsersOptions = () => {
  return queryOptions({
    queryKey: QUERY_KEYS.ALL_USERS(),
    queryFn: () => getAllUsersAPI(),
  });
};
export const useGetAllUsers = () => {
  return useQuery(getAllUsersOptions());
};

